<template>
    <!-- 租赁柜 -->
    <el-form v-loading="loading">
        <div class="rental-cabinet-components">
            <div class="rental-cabinet-search flex items-center">
                <el-input
                    @keyup.enter.native="fetchData(1)"
                    class="rental-cabinet-search-input"
                    v-model="form.keyword"
                    :placeholder="$t('Common.client_tip2')">
                </el-input>
                <div class="pl-6">
                    <el-button
                        type="primary"
                        @click="fetchData(1)">
                        {{ $t('Common.search') }}
                    </el-button>
                    <el-button @click="resetForm">{{ $t('Common.clear') }}</el-button>
                </div>
            </div>

            <div class="container-content">
                <div class="content-store">
                    <div class="content-title flex justify-between">
                        <div class="flex items-center">{{ $t('Reception.Fourth.area') }}</div>
                        <div class="flex">
                            <el-tooltip effect="dark" :content="$t('tooltip.add')" placement="bottom">
                                <div
                                    class="iconfont add icon-fitness-tianjiawenjian"
                                    @click="handleArea('add')"
                                ></div>
                            </el-tooltip>
                            <el-tooltip effect="dark" :content="$t('tooltip.edit')" placement="bottom">
                                <div
                                    class="iconfont
                                    edit
                                    icon-fitness-icon-test-copy-copy-copy-copy-copy-copy-copy-copy-copy"
                                    @click="handleArea('edit')"
                                ></div>
                            </el-tooltip>
                            <el-tooltip effect="dark" :content="$t('tooltip.delete')" placement="bottom">
                                <div
                                    class="iconfont delete icon-fitness-shanchu"
                                    @click="handleDeleteArea"
                                ></div>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="content-info">
                        <div v-for="(i, index) in lockerArea" :key="index">
                            <div>{{ i.storeName }}</div>
                            <ul
                                class="cabinet-ul"
                                v-for="(item, iindex) in i.areas"
                                :key="`child-${iindex}`">
                                <li class="cabinet-li"
                                    @click="changeList(item.id)"
                                    :class="clickIndex == item.id ? 'clicked' : ''">
                                    {{ item.name }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="content-select">
                    <div class="content-title flex justify-between">
                        <div class="flex items-center">{{ $t('Reception.Fifth.small_title') }}</div>
                        <div class="flex">
                            <el-tooltip effect="dark" :content="$t('tooltip.add')" placement="bottom">
                                <div
                                    class="iconfont add icon-fitness-tianjiawenjian"
                                    @click="handleAdd"
                                ></div>
                            </el-tooltip>
                            <el-tooltip effect="dark" :content="$t('tooltip.edit')" placement="bottom">
                                <div
                                    class="iconfont
                                    edit
                                    icon-fitness-icon-test-copy-copy-copy-copy-copy-copy-copy-copy-copy"
                                    @click="handleEdit"
                                ></div>
                            </el-tooltip>
                            <el-tooltip effect="dark" :content="$t('tooltip.delete')" placement="bottom">
                                <div
                                    class="iconfont delete icon-fitness-shanchu"
                                    @click="handleDelete"
                                ></div>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="content-info">
                        <el-table
                            ref="multipleTable"
                            :data="tableData"
                            tooltip-effect="dark"
                            style="width: 100%;margin-bottom: 15px;"
                            border
                            @row-click="clickRow"
                            @selection-change="handleSelectionChange">
                            <el-table-column type="selection" />
                            <el-table-column prop="storeAreaName" :label="$t('Reception.Fourth.area1')" />
                            <el-table-column prop="initial" :label="$t('Reception.Fourth.letter')" />
                            <el-table-column prop="lockerNum" :label="$t('Reception.Fifth.number')" />
                            <el-table-column prop="price" :label="$t('Reception.Fifth.price')" />
                            <el-table-column prop="transferFee" :label="$t('Reception.Fifth.fee')" />
                            <el-table-column prop="salesStatus" :label="$t('Reception.Fifth.sale_status')" />
                            <el-table-column prop="physicalStatus" :label="$t('Reception.Fifth.phy_status')" />
                            <el-table-column prop="address" :label="$t('Reception.Fifth.bind')" >
                                <template slot-scope="{row}">
                                    {{ $t('Reception.Fifth.wei_bind') }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="duration" :label="$t('Reception.Fifth.end_time')" />
                            <el-table-column :label="$t('Reception.Fourth.name')" >
                                <template slot-scope="{row}">
                                    <span
                                        class="clicked cursor-pointer"
                                        @click="handleUser(row.clientId)">
                                        {{ row.clientName }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="clientPhone" :label="$t('Reception.Fourth.phone')" />
                        </el-table>
                        <el-pagination
                            v-if="tableData && tableData.length"
                            class="text-right"
                            @current-change="fetchData"
                            :current-page.sync="form.page"
                            :page-size="pagination.size"
                            layout="total, prev, pager, next, jumper"
                            :total="pagination.total">
                        </el-pagination>
                    </div>
                </div>
            </div>

            <!-- 添加/编辑区域 -->
            <add-area ref="area" @fetchLocker="fetchLocker"/>
            <!-- 添加租赁柜 -->
            <add-cabinet ref="cabinet" @fetchLocker="fetchLocker"/>
            <!-- 编辑租赁柜  -->
            <edit-sell-cabinet ref="edit" @fetchData="fetchData"/>
        </div>
    </el-form>
</template>

<script>
import handleUser from '@/mixins/handleUser.js';
import AddArea from '@/components/Dialog/Reception/AddArea';
import AddCabinet from '@/components/Dialog/Reception/AddCabinet';
import EditSellCabinet from '@/components/Dialog/Reception/EditSellCabinet';

export default {
    name: 'cabinet-locker',
    components: {
        AddArea,
        AddCabinet,
        EditSellCabinet,
    },
    mixins: [handleUser],
    data() {
        return {
            pagination: {
                size: 10,
                total: 0,
            },
            form: {
                keyword: '',
                page: 1,
                areaId: 1,
            },
            lockerArea: [],
            formData: [],
            defaultProps: {
                children: 'children',
                label: 'label',
            },
            tableData: [],
            deleteIds: [],
            area: [],
            clickIndex: null,
            loading: false,
        };
    },
    created() {
        this.fetchLocker();
    },
    methods: {
        permission () {
            if (this.$$filterPermission('前台-钥匙牌管理-区域及钥匙牌生成和删除 区域编辑')) return true;
            else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
                return false;
            }
        },
        permissionStatus() {
            if (this.$$filterPermission('前台-钥匙牌管理-钥匙牌状态变更')) return true;
            else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
                return false;
            }
        },
        fetchLocker() {
            API.get('area/locker').then(res => {
                this.lockerArea = res;
                // 赋值
                this.clickIndex = this.clickIndex ? this.clickIndex : res[0].areas[0].id;
                this.form.areaId = this.clickIndex;
                this.fetchData(1);
            });
        },
        fetchData(page = null) {
            if (!this.$$filterPermission('前台-租赁柜管理-租赁柜搜索及查看')) return;
            this.loading = true;
            if (page) this.form.page = page;
            API.get('locker/pages', {params: this.form}).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
            }).finally(() => this.loading = false);
        },
        handleArea(type) {
            const itemObj = {
                storeId: null,
                name: null,
                id: null,
            };
            this.lockerArea.forEach(el => {
                el.areas.map(item => {
                    if (item.id === this.clickIndex) {
                        if (type === 'edit') {
                            itemObj.name = item.name;
                            itemObj.id = item.id;
                        }
                        itemObj.storeId = el.storeId;
                    }
                    return itemObj;
                });
            });
            // 传入门店id,当前区域名
            if (this.permission()) this.$refs.area.open(itemObj.storeId, itemObj.name, itemObj.id, type);
        },
        handleDeleteArea() {
            const id = this.clickIndex;
            $ele.$confirm(this.$t('Reception.Fifth.dialog_delete'), this.$t('Message.tip_title'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                if (this.permission()) {
                    API.delete(`area/${id}`).then(() => {
                        // 删除接口
                        $ele.$message.success(this.$t('Message.delete_success'));
                        this.clickIndex = null;
                        this.fetchLocker();
                    });
                }
            }).catch(() => {
                // $ele.$message('取消操作');
            });
        },
        // 租赁柜添加
        handleAdd() {
            let storeId;
            this.lockerArea.forEach(el => {
                el.areas.map(item => {
                    if (item.id === this.clickIndex) storeId = el.storeId;
                });
            });
            if (this.permission()) this.$refs.cabinet.open(2, storeId);
        },
        // 编辑
        handleEdit() {
            if (this.deleteIds.length !== 1) $ele.$message.info(this.$t('Message.tip_one'));
            else if (this.permission() || this.permissionStatus()) this.$refs.edit.open(this.deleteIds[0]);
        },
        // 租赁柜删除
        handleDelete() {
            if (this.deleteIds.length) {
                $ele.$confirm(this.$t('Reception.Fifth.delete_confirm'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Common.cancel'),
                    type: 'warning',
                }).then(() => {
                    if (this.permissionStatus()) {
                        // 删除接口
                        const ids = this.deleteIds.join(',');
                        API.delete(`locker/${ids}`).then(() => {
                            $ele.$message.success(this.$t('Message.delete_success'));
                            this.fetchLocker();
                        });
                    }
                }).catch(() => {
                    // $ele.$message('取消操作');
                });
            } else {
                $ele.$message(this.$t('Message.tip_one'));
            }
        },
        handleSelectionChange(val) {
            if (val.length) {
                this.deleteIds = val.map(el => el.id);
            } else {
                this.deleteIds = [];
            }
        },
        clickRow(row) {
            this.$refs.multipleTable.toggleRowSelection(row);
        },
        changeList(id) {
            this.clickIndex = id;
            this.form.areaId = this.clickIndex;
            // 接口获取数据
            this.fetchData(1);
        },
        resetForm() {
            this.form.keyword = null;
            this.fetchData(1);
        },
    },
};
</script>

<style lang="scss">
.rental-cabinet-components {
    .rental-cabinet-search {
        width: 100%;
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 15px;
        margin-bottom: 15px;
    }
    .rental-cabinet-search-input {
        width: 400px;
    }
    .container-content {
        font-size: 14px;
        color: #666;
    }
    .content-store,
    .content-select {
        width: 25%;
        margin-right: 1%;
        border: 1px solid #e6e6e6;
        display: inline-block;
        vertical-align: text-top;
        display: inline-block;
        vertical-align: top;
    }
    .content-select {
        width: 74%;
        margin-right: 0;
    }
    .content-title {
        font-size: 13px;
        background: #fafafa;
        padding: 18px 20px;
        border-bottom: 1px solid #e6e6e6;
    }
    .add,
    .delete,
    .edit {
        color: #697a8e;
    }
    .add {
        font-size: 18px;
    }
    .edit {
        margin: 0 12px;
    }
    .content-info {
        color: rgb(102, 102, 102);
        padding: 15px;
        font-size: 13px;
    }
    ul.cabinet-ul {
        padding-left: 15px;
    }
    li.cabinet-li {
        list-style: none;
        list-style-position: inside;
        margin: 15px 0;
        cursor: pointer;
    }
    .clicked {
        color: #05abef;
    }
}
</style>
